import React from 'react';

import ComplexPartner from '../complexPartner';

const steps = {
	initial: 0,
	documentation: 1,
	set_customer_id: 2,
	set_service_id: 3,
	set_outlet_id: 4,
	set_default_payment_id: 5,
	set_ipad_token: 6,
	set_api_data: 6,
	check_liveness: 6,
	set_auth_link: 6,
	set_api_mask: 6,
	set_auth_group: 6,
	set_entities: 6,
	link_external_data: 6,
	trigger_synchro: 6,
	success: 7,
};

const Mews = props => {
	return (
		<ComplexPartner
			key_={props.key_}
			index={props.index}
			setBlurBackground={props.setBlurBackground}
			steps={steps}
		/>
	);
};

export default Mews;
